/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".page_banner[_ngcontent-%COMP%]{background:url(/assets/images/login.jpg) center center no-repeat #333;position:relative;margin-bottom:30px}.bgamarelo[_ngcontent-%COMP%]{background-color:#fba529!important}.bgcinza[_ngcontent-%COMP%]{background-color:#737373!important}.bgvermelho[_ngcontent-%COMP%]{background-color:#d43b3b!important}.msg[_ngcontent-%COMP%]{padding:10px 20px}\n/*# sourceMappingURL=ativacao-usuario.component.css.map*/"];
export { styles as styles };
